import dayjs from 'src/Helpers/dayjs'
import { CampaignStatusEnum } from 'src/Types/campaigns'

export const getIsTrackLinkBlockVisible = (
  isPreRelease: boolean | undefined,
  releaseDate: string | null | undefined,
  status: CampaignStatusEnum | undefined,
  playlistsAdds: number | undefined,
  spotifyId: string | null | undefined,
): boolean => {
  if (
    !releaseDate ||
    !dayjs().isAfter(dayjs.utc(releaseDate)) ||
    (spotifyId !== null && spotifyId !== '')
  ) {
    return false
  }
  const isRunning =
    status === CampaignStatusEnum.RUNNING && Boolean(isPreRelease)
  const isEndedWithPlacements =
    status === CampaignStatusEnum.ENDED && Boolean(playlistsAdds)
  return isRunning || isEndedWithPlacements
}
